<div class="drawer-container">
  <div class="drawer-content">
    <div class="product-info-section">
      <div class="product-info">
        <span class="product-code">{{ data.stock.productCode }}</span>
        <span class="product-name">{{ data.stock.productName }}</span>
        <span class="store-info">{{ data.stock.storeName }} - {{ 'pages.stock.current_quantity' | translate }}: {{
          data.lot.stockQuantity }}</span>
      </div>
    </div>

    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-spinner"></div>
      <p>{{ 'common.loading' | translate }}</p>
    </div>

    <div *ngIf="currentView === EditOptionIds.OPTIONS && !isLoading" class="options-container">
      <div class="options-grid">
        <div *ngFor="let option of editOptions" class="option-card" (click)="onOptionSelected(option.id)">
          <div class="option-icon">
            <img [src]="'/assets/icons/backoffice/' + option.icon + '.svg'" [alt]="option.title | translate">
          </div>
          <div class="option-content">
            <h3>{{ option.title | translate }}</h3>
            <p>{{ option.description | translate }}</p>
          </div>
          <div class="option-arrow">→</div>
        </div>
      </div>
    </div>

    <div *ngIf="currentView === EditOptionIds.QUANTITY && !isLoading" class="form-container">
      <app-stock-quantity-form [stockData]="data.lot" (formSubmitted)="onQuantityFormSubmitted()"
        (stepBackEmitter)="goBack()">
      </app-stock-quantity-form>
    </div>
    <div *ngIf="currentView === EditOptionIds.LOCATION && !isLoading" class="form-container">
      <app-stock-location-form [stockData]="data.lot" (formSubmitted)="onLocationFormSubmitted($event)"
        (stepBackEmitter)="goBack()">
      </app-stock-location-form>
    </div>
    <div *ngIf="currentView === EditOptionIds.COST && !isLoading" class="form-container">
      <app-stock-cost-form [stockData]="data.lot" (formSubmitted)="onCostFormSubmitted($event)"
        (stepBackEmitter)="goBack()">
      </app-stock-cost-form>
    </div>

    <div *ngIf="currentView === EditOptionIds.TRANSFER && !isLoading" class="form-container">
      <app-stock-transfer-form [stockData]="data" (formSubmitted)="onTransferFormSubmitted()"
        (stepBackEmitter)="goBack()">
      </app-stock-transfer-form>
    </div>
  </div>
</div>